import Image from "next/image";
import styles from "./LowBalanceChatCart.module.scss";
import { Feed_CALL_BUTTON_ICONS } from "@/utils/imageRelativePaths";

const LowBalanceChatCart = ({
  show,
  onClose,
}: {
  show: boolean;
  onClose: () => void;
}) => {
  return (
    <div
      className={`${styles.low_balance_cart} ${show ? styles.isVisibal : ""}`}
    >
      <span>You have a low balance.</span>{" "}
      {/* <button className={styles.recharge_btn}>Recharge</button> */}
      <div className={styles.close_icon} onClick={() => onClose()}>
        <Image
          src={Feed_CALL_BUTTON_ICONS.CLOSE_ICON_SMALL}
          alt="close"
          height={8}
          width={8}
        />
      </div>
    </div>
  );
};

export default LowBalanceChatCart;
